
/**
 * @see mobiz1:Mobiz.Core.Models.Common.MobizNotificationPriority
 */
export enum MobizNotificationPriority {
  /** The notification implies that an action needs to be taken. */
  ActionRequired = 1,
  /** The notification implies that an important message needs to be relayed. */
  Important = 2,
  /** The notification implies that an message might be helpful to be relayed. */
  FYI = 3,
  /** The notification implies that an system event has occurred. */
  System = 4
}
